// PrimeVue plugin
import PrimeVue from "primevue/config";
// Read more about PrimeVue configuration at https://primevue.org/configuration/
const options = {};
export default {
    install: (app) => {
        app.use(PrimeVue, options);
    }
};
